import script from "./DashboardEnvironments.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardEnvironments.vue?vue&type=script&setup=true&lang=js"

import "./DashboardEnvironments.vue?vue&type=style&index=0&id=61558961&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61558961"]])

export default __exports__